import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasElectricity = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('has_electricity')(jsonQuery),
);
